import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import Classes from './ClassesTable';
import ClassPage from './ClassPage';

const ClassesRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    console.log('ClassesRoutes path', path);

    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={Classes} />
                <Route exact path={`${path}/:classUuid`} component={ClassPage} />
            </Switch>
        </>
    );
};

export default ClassesRoutes;
